export const getCachedInfo = (state) => {
  return state.VNOTP.get('cached_info')
}

export const getShift4Token = (state) => {
  return state.VNOTP.get('shift4_token')
}
